export const small = '500px'
export const tablet = '820px'
export const desktop = '990px'
export const desktopLarge = '1170px'
